export default "__VITE_ASSET__Bl4wx1qp__"